import { fetcher } from '@commenda/utils';

import { IApiResponse } from './types';

export interface IRenameDriveViewFolderParams {
  folderId: string;
  name: string;
}

export async function renameDriveViewFolder({
  folderId,
  name,
}: IRenameDriveViewFolderParams): Promise<IApiResponse<null>> {
  const response = await fetcher('drive-view/folder/rename', {
    method: 'POST',
    body: { folderId, name },
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    return {
      success: false,
      error: body?.message || 'Failed to rename folder',
      statusCode: response.status,
      data: null,
    };
  }

  return {
    success: true,
    error: null,
    statusCode: response.status,
    data: null,
  };
}
